import { IntroductionButton, RemarkButton } from '@Components/IconButton';
import { Box, Divider } from '@mui/material';
import DeleteReportButton from '@Router/Landing/Containers/DeleteReportButton';
import DownloadCVUP from '../Landing/Containers/ReportDetail/DownloadCVUP/DownloadCVUP';
import Alerts from './Alerts';
import Buttons from './Buttons';
import FormCheckboxs from './FormCheckboxs';
import FormDatePickers from './FormDatePickers';
import FormFileInputs from './FormFileInputs';
import FormInputs from './FormInputs';
import FormRadioButtons from './FormRadioButtons';
import FormSelects from './FormSelects';
import Inputs from './Inputs';
import Palettes from './Palettes';
import Selects from './Select';
import Typographys from './Typographys';
import DataGrid from './DataGrid';

const Playground = () => {
  return (
    <Box className="playground" p={2}>
      <Palettes />
      <Divider sx={{ my: 2 }} />
      <Buttons />
      <Divider sx={{ my: 2 }} />
      <Typographys />
      <Divider sx={{ my: 2 }} />
      <Inputs />
      <Divider sx={{ my: 2 }} />
      <FormInputs />
      <Divider sx={{ my: 2 }} />
      <Selects />
      <Divider sx={{ my: 2 }} />
      <FormSelects />
      <Divider sx={{ my: 2 }} />
      <FormCheckboxs />
      <Divider sx={{ my: 2 }} />
      <DeleteReportButton />
      <Divider sx={{ my: 2 }} />
      <DownloadCVUP />
      <Divider sx={{ my: 2 }} />
      <FormDatePickers />
      <Divider sx={{ my: 2 }} />
      <FormRadioButtons />
      <Divider sx={{ my: 2 }} />
      <FormFileInputs />
      <Divider sx={{ my: 2 }} />
      <IntroductionButton />
      <RemarkButton />
      <Divider sx={{ my: 2 }} />
      <Alerts />
      <Divider sx={{ my: 2 }} />
      <DataGrid />
    </Box>
  );
};

export default Playground;
